import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { AuthService } from './core/auth/auth.service';
import { SplashScreenComponent } from './modules/shared/containers/splash-screen/splash-screen.component';
import { ConfigurationService } from './modules/shared/services/configuration.service';
import { SvgIconService } from './modules/shared/services/svg-icon.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [RouterOutlet, SplashScreenComponent]
})
export class AppComponent implements OnInit {
    /**
     * Constructor
     */
    constructor(
        private _config: ConfigurationService,
        private _authService: AuthService,
        private _svgService: SvgIconService,
        private _router: Router,
    ) {
        console.log('*** init App component ***');
        this._config.setConfiguration();
    }

    ngOnInit(): void {
        const pathname = window.location.pathname;
        const publicRoutes = [
            '/emergency-center-agent-access',
            '/tunstall-emergency-list',
            '/ext/wifi-setting',
            // '/support/help-center',
            '/public/support/help-center/faq',
            // '/public/support/help-center/guidelines',
            '/public/support/help-center/guidelines/video',
            '/public/support/help-center/guidelines/legal',
            '/public/support/help-center/guidelines/legal/legal-information/imprint',
            '/public/support/help-center/guidelines/legal/legal-information/privacy-policy',
            '/public/support/help-center/guidelines/legal/legal-information/terms-of-use-for-the-alpha-app',
            '/public/support/help-center/guidelines/legal/security/security-tips',
            '/user-health-stats',
            '/.well-known/security.txt'
        ];
        const shortUrl = '/s/';

        // For help-center public
        const user = this._authService.getStore('user');

        let isSearchPathFAQ = false;
        const guidelinesFAQRoute = '/support/help-center/faq';
        if (!user && (pathname == guidelinesFAQRoute || pathname == '/faq')) {
            this._router.navigate(['/public/support/help-center/faq']);
            return;
        } else if (
            user &&
            (pathname == guidelinesFAQRoute || pathname == '/faq')
        ) {
            isSearchPathFAQ = true;
        }

        // handing video url
        let isSearchPathVideo = false;
        const guidelinesVideoRoute = '/support/help-center/guidelines/video';
        if (
            !user &&
            (pathname == guidelinesVideoRoute ||
                pathname == '/video' ||
                pathname == '/videos')
        ) {
            this._router.navigate([
                '/public/support/help-center/guidelines/video',
            ]);
            return;
        } else if (
            user &&
            (pathname == guidelinesVideoRoute ||
                pathname == '/video' ||
                pathname == '/videos')
        ) {
            isSearchPathVideo = true;
        }

        // handing legal url
        let isSearchPathLegal = false;
        const guidelinesLegalRoute = '/support/help-center/guidelines/legal';
        if (
            !user &&
            (pathname == guidelinesLegalRoute || pathname == '/legal')
        ) {
            this._router.navigate([
                '/public/support/help-center/guidelines/legal',
            ]);
            return;
        } else if (
            user &&
            (pathname == guidelinesLegalRoute || pathname == '/legal')
        ) {
            isSearchPathLegal = true;
        }

        if (pathname.includes('pnc-central-call')) {
            this._router.navigate([pathname]);
            return;
        }

        if (!pathname?.includes(shortUrl)) {
            if (publicRoutes?.includes(pathname)) {
                console.log('public');
            } else {
                console.log('login');
                this._authService.configureSingleSignOn();
                this._authService.registerBackgroundingReauth();
                this._authService.registerIdleAutoLogout();
                if (isSearchPathVideo) {
                    this._router.navigate([guidelinesVideoRoute]);
                }
                if (isSearchPathLegal) {
                    this._router.navigate([guidelinesLegalRoute]);
                }
                if (isSearchPathFAQ) {
                    this._router.navigate([guidelinesFAQRoute]);
                }
            }
        }

        this._svgService.addIcons();
    }
}
